module.exports = "<div id=\"loaderModule\" *ngIf=\"loading\">\r\n\t<div class=\"load\">\r\n\t\t<div>\r\n\t\t\t<img src=\"assets/img/load.gif\" />\r\n\t\t\t<!--<br />-->\r\n\t\t\t<p>Aguarde, carregando<span id=\"loaderText\">{{content}}</span>...</p>\r\n\t\t</div>\r\n\t</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loader/loader.component.html
// module id = ./src/app/shared/loader/loader.component.html
// module chunks = main